import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { expandTheme } from 'utils/theme-util';

export const NonDeliveryDaysStyles = (theme: Theme) =>
  createStyles({
    addButton: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      backgroundColor: expandTheme(theme).palette.primary.green,
      color: expandTheme(theme).palette.primary.white,
      textTransform: 'none' as const,
    },
    snackbar: {
      backgroundColor: expandTheme(theme).palette.primary.grey2,
      borderRadius: 0,
      boxShadow: 'none',
      color: theme.palette.text.primary,
      fontSize: theme.typography.fontSize * 1.1,
    },
    title: {
      minWidth: 140,
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    checkboxGrid: {
      display: 'flex',
      alignItems: 'center',
    },
    checkboxItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  });
